import { alpha, Card, styled } from '@mui/material';
import { MdArrowBack } from 'react-icons/md';
import { Link } from 'react-router-dom';

export const ContainerStyled = styled('div')(({ theme }) => ({
  marginTop: 16,
  '& a': {
    color: theme.palette.secondary.main,
    fontFamily: 'montserrat',
    fontSize: 14,
    margin: 16,
    '@media(min-width: 751px)': {
      display: 'none',
    },
  },
}));

export const GoBackContainerStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  margin: '2rem 0 0 4rem',
  '& h1': {
    color: theme.palette.primary.main,
    marginLeft: '1rem',
  },
  '@media (max-width: 750px)': {
    display: 'none',
  },
}));

export const IconBackStyled = styled(MdArrowBack)(({ theme }) => ({
  color: theme.palette.primary.main,
  cursor: 'pointer',
  '&:hover': {
    color: alpha(theme.palette.primary.main, 0.7),
  },
}));

export const MobileContainerStyled = styled('div')(({ theme }) => ({
  paddingBottom: 24,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '& a': {
    textAlign: 'initial',
  },
  '& p': {
    color: theme.palette.global.lightgray,
    fontSize: 15,
  },
  '& p + p': {
    color: theme.palette.secondary.main,
    fontSize: 15,
  },
  '@media(min-width: 751px)': {
    display: 'none',
  },
}));

export const ConstructionDetailsContainerStyled = styled('div')(
  ({ theme }) => ({
    width: '95%',
    backgroundColor: alpha(theme.palette.secondary.main, 0.2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 6,
    padding: 8,
    borderRadius: 8,
    marginTop: 16,
  })
);

export const ContainerCardsStyled = styled('div')({
  width: '95%',
});

export const PaymentCardStyled = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  '& p': {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
  '& .card': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '5rem',
    '& svg': {
      fontSize: 32,
    },
    '& p': {
      fontWeight: 400,
    },
  },
}));

export const PayablesCardStyled = styled('div')({
  textDecoration: 'none',
  padding: '12px 0px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  '& .payment': {
    color: '#434242',
    fontWeight: 'normal',
    fontSize: 13,
    '& .paid': {
      color: '#29D17D',
    },
    '& .pending': {
      color: '#FF4A56',
    },
  },
});

export const RootStyled = styled('div')(({ theme }) => ({
  padding: theme.spacing(8),
  margin: '0 auto',
  marginTop: '-40px',
  maxWidth: '1920px',
  '@media (max-width: 750px)': {
    display: 'none',
  },
}));

export const CardDetailsStyled = styled(Card)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  '& .leftCard': {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: 16,
    '& p': {
      color: theme.palette.secondary.main,
      fontWeight: 'bold',
      fontSize: 15,
    },
    '& svg': {
      fontSize: 20,
      color: theme.palette.primary.main,
    },
  },
  '& .rigthCard': {
    display: 'flex',
    alignItems: 'center',
    paddingRight: 8,
    gap: 8,
    '& p': {
      color: theme.palette.secondary.main,
      fontSize: 15,
    },
    '& svg': {
      fontSize: 20,
      color: theme.palette.primary.main,
    },
  },
  '& + .MuiPaper-root': {
    marginTop: 12,
  },
}));
